/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import dash from "../images/dash.png"
import "typeface-playfair-display"
import "typeface-roboto"
import "./all.sass"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
        <div className="site-content-wrapper">
        <Header siteTitle={data.site.siteMetadata.title} />
        <main className="content">{children}</main>
        </div>
        <footer>
          <div className="container">
            <p className="has-text-centered">
              © {new Date().getFullYear()}, {data.site.siteMetadata.title}<br />
              16107 Kensington Dr #199<br />
              Sugar Land, TX  77479-4224</p>
            <p className="has-text-centered">Website provided by <a href="https://touchstonedistrictservices.com">Touchstone</a><br />
              <img width="40" src={dash} alt="" />
            </p>
          </div>
        </footer>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
